module.exports = __webpack_public_path__ + "static/media/README.0fc731b7.md";